import { render, staticRenderFns } from "./EditEstablishmentTransferPage.vue?vue&type=template&id=7f791548"
import script from "./EditEstablishmentTransferPage.vue?vue&type=script&lang=js"
export * from "./EditEstablishmentTransferPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports